import React from "react";

import { Config } from "../../../../shared/core/config/config";
import { configurationManager } from "../../../../shared/core/service/services";
import { useObservable } from "../../../../shared/utils/observable";
import { ArticlePage } from "../../common/article-page";

export const DeleteAccount = () => {
  const configuration = useObservable(configurationManager.configuration);
  const contactMail = configuration.contactEmail;
  const appName = Config.APP_NAME;

  return (
    <ArticlePage
      mainTitle={`Request to delete your account on ${appName}`}
      intro={`This article explains how to request deletion of your personal data collected via the ${appName}.`}
      sections={[
        {
          title: "Steps to Delete Your Account",
          content: (
            <ol className="list">
              <li className="list__item">Open the {appName} on your mobile device</li>
              <li className="list__item">
                Go to <strong>Settings</strong> &gt; <strong>Account Settings</strong>
              </li>
              <li className="list__item">
                Select <strong>Delete My Account</strong>
              </li>
              <li className="list__item">Confirm your identity and follow the on-screen instructions</li>
            </ol>
          ),
        },
        {
          title: "",
          content: (
            <p>
              Alternatively, you may contact our support team at <a href={`mailto:${contactMail}`}>{contactMail}</a>{" "}
              with the subject line: <em>"Request to Delete My Account - {appName}"</em>.
            </p>
          ),
        },
        {
          title: "What Data Will Be Deleted?",
          content: (
            <ul className="list">
              <li className="list__item">Your user profile and login credentials</li>
              <li className="list__item">Personal identification data (name, email, phone number)</li>
              <li className="list__item">Transaction history associated with your account</li>
            </ul>
          ),
        },
        {
          title: "Data We May Retain",
          content: (
            <p>Some financial or regulatory data may be retained for up to 5 years as required by applicable law.</p>
          ),
        },
        {
          title: "Processing Time",
          content: (
            <p>
              We will process your deletion request within <strong>7 business days</strong>.
            </p>
          ),
        },
        {
          title: "Need Help?",
          content: (
            <p>
              Email us at <a href={`mailto:${contactMail}`}>{contactMail}</a>
            </p>
          ),
        },
      ]}
    />
  );
};
